// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bottomContainer[data-v-039d58eb]{\n  margin: 20px;\n  background: #fff;\n  border-radius: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
